(function ($) {
  var content = $("#shopify-section-page-rewards .rewards-content");
  var openBox = false;
  var level = 1;
  var levels = [
    {
      value: 1,
      title: "Taster",
      offers: [
        "10% OFF FIRST PURCHASE",
        window.shopifyCurrency.symbol + "5 ON YOUR BIRTHDAY",
        "FIRST ACCESS TO PRODUCT LAUNCHES & MEMBER-ONLY SALES",
        window.shopifyCurrency.symbol + "5 REFERRAL FOR YOU AND YOUR BESTIE",
      ],
    },
    {
      value: 2,
      title: "Sweet Tooth",
      offers: [
        "10% OFF FIRST PURCHASE IN THE NEW TIER",
        window.shopifyCurrency.symbol + "10 ON YOUR BIRTHDAY",
        "FIRST ACCESS TO PRODUCT LAUNCHES & MEMBER-ONLY SALES",
        window.shopifyCurrency.symbol + "5 REFERRAL FOR YOU AND YOUR BESTIE",
      ],
    },
    {
      value: 3,
      title: "Foodie",
      offers: [
        "15% OFF FIRST PURCHASE IN THE NEW TIER",
        window.shopifyCurrency.symbol + "10 ON YOUR BIRTHDAY",
        "FIRST ACCESS TO PRODUCT LAUNCHES & MEMBER-ONLY SALES",
        window.shopifyCurrency.symbol + "5 REFERRAL FOR YOU AND YOUR BESTIE",
        "AN EXTRA 15 POINTS FOR EVERY " + window.shopifyCurrency.symbol + "80 SPENT IN ONE PURCHASE",
        "FREE GIFT UP TO " + window.shopifyCurrency.symbol + "20",
      ],
    },
    {
      value: 4,
      title: "Connoisseur",
      offers: [
        "20% OFF FIRST PURCHASE IN THE NEW TIER",
        window.shopifyCurrency.symbol + "15 ON YOUR BIRTHDAY",
        "FIRST ACCESS TO PRODUCT LAUNCHES & MEMBER-ONLY SALES",
        window.shopifyCurrency.symbol + "5 REFERRAL FOR YOU AND YOUR BESTIE",
        "AN EXTRA 25 POINTS FOR EVERY " +
          window.shopifyCurrency.symbol +
          "100 SPENT IN ONE PURCHASE",
        "FREE GIFT UP TO " + window.shopifyCurrency.symbol + "40",
      ],
    },
  ];

  function render(first) {
    var item = levels.find(function (i) {
      return i.value === level;
    });
    var board = content.find(".rewards-board");
    var box = content.find(".rewards-board-box");
    var ul = box.find("ul");
    var buttons = content.find(".rewards-board-buttons ul");
    var benefits = content.find(".rewards-benefits");
    content.attr("class", "rewards-content rewards-level-" + level);
    if (openBox) {
      board.addClass("rewards-board-box-open");
    }
    box.find("h4").text("Level " + item.value + ":");
    box.find("h3").text(item.title);
    ul.html("");
    item.offers.forEach(function (offer) {
      ul.append($("<li>").text(offer));
    });
    if (first) {
      var closeBoard = function () {
        openBox = false;
        board.removeClass("rewards-board-box-open");
        return false;
      };
      buttons.html("");
      board
        .find(".rewards-board-backdrop")
        .off("click")
        .on("click", closeBoard);
      box
        .find(".rewards-board-box-close")
        .off("click")
        .on("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          return closeBoard();
        });
      benefits.find(".rewards-benefits-arrows button").on("click", function () {
        benefits.attr("class", "rewards-benefits");
        benefits.addClass("rewards-benefits-page-" + $(this).data("target"));
      });
      levels.forEach(function (i) {
        buttons.append(
          $("<li>")
            .addClass("rewards-level-" + i.value)
            .append(
              $('<button type="button">')
                .text(i.title)
                .off("click")
                .on("click", function () {
                  level = i.value;
                  openBox = true;
                  render();
                })
            )
        );
      });
    }
  }

  render(true);
})(jQuery);
